/**
 * Ceny se vsude uvnitr drzi v **minoritnich jednotkach** (halere, grosze,
 * centy) jako cela cisla. Duvod je scitani: rezim nakupovani secita desitky
 * polozek ve trech menach a s desetinnymi cisly by soucet driv nebo pozdeji
 * skoncil na 34,879999999. Prevod na desetinne cislo se dela az pri zobrazeni.
 */
export function toMinor(value) {
    return Math.round(value * 100);
}
/**
 * Horni mez ceny: 999 999,99 v jakekoli mene. Sloupec je int4 a vetsi cislo
 * by databaze odmitla — preklep v obchode se musi zastavit uz ve formulari.
 */
export const MAX_PRICE_MINOR = 99_999_999;
/** Mnozstvi a poradi polozky: jen pojistka proti preklepu, ne obchodni pravidlo. */
export const MAX_QTY = 100_000;
export const MAX_POSITION = 1_000_000;
export function fromMinor(minor) {
    return minor / 100;
}
const LOCALE = 'cs-CZ';
/**
 * `narrowSymbol`, protoze v locale cs-CZ by zloty vysly jako "3,49 PLN".
 * Na cedulce v regalu v Bogatynii je "zł" — a s tou sestra cenu porovnava.
 */
export function formatMoney(minor, currency) {
    if (minor === null || currency === null)
        return '—';
    return new Intl.NumberFormat(LOCALE, {
        style: 'currency',
        currency,
        currencyDisplay: 'narrowSymbol',
        maximumFractionDigits: 2,
    }).format(fromMinor(minor));
}
/** "zł", "€", "Kč" — do popisku formularu misto kodu meny. */
export function currencySymbol(currency) {
    const parts = new Intl.NumberFormat(LOCALE, {
        style: 'currency',
        currency,
        currencyDisplay: 'narrowSymbol',
    }).formatToParts(0);
    return parts.find((p) => p.type === 'currency')?.value ?? currency;
}
/** Vraci null, kdyz kurz chybi — radsi nic nez vymysleny soucet. */
export function toCzkMinor(minor, currency, fx) {
    if (currency === 'CZK')
        return minor;
    const rate = currency === 'EUR' ? fx.eurCzk : fx.plnCzk;
    if (rate === null)
        return null;
    return Math.round(minor * rate);
}
//# sourceMappingURL=money.js.map